import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { of } from 'rxjs';

import { Role } from '@fry/lib/roles';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { SecurityService } from '@fry/lib/security';
import { LanguageService } from '@fry/lib/organisations/language.service';

@Component({
    selector: 'app-role-slot',
    templateUrl: './role-slot.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoleSlotComponent implements OnInit {
  @Input() role: Role;

  public buttons: EASLinkAction[];

  constructor(
    private security: SecurityService,
    private language: LanguageService,
  ) { }

  ngOnInit() {
    const originalLanguageCode = this.language.getOriginalLanguageCode();
    const translationLanguageCodes = this.language.getTranslationLanguageCodes();

    const translateButtons: EASLinkAction[] = translationLanguageCodes.map(translationLanguageCode => ({
      type: 'link',
      label: $localize `Edit translation (${translationLanguageCode})`,
      condition: () => {
        return this.security.hasPermission('translations.view');
      },
      link: of(['/', 'translation', this.role.doc.type, this.role.doc._id, translationLanguageCode])
    }));

    this.buttons = [
      {
        type: 'link',
        label: translationLanguageCodes.length === 0 ? $localize `Edit` : $localize `Edit original (${originalLanguageCode})` ,
        condition: () => {
          return of(true);
        },
        link: of([this.role.doc._id, 'edit'])
      },
      ...translateButtons,
      {
        type: 'link',
        label: $localize `Duplicate`,
        condition: () => this.security.hasPermission('roles.edit'),
        link: of([this.role.doc._id, 'duplicate'])
      }
    ];
  }

  onSubmit() {
  }
}
